import "./component.scss";
import initJiffyFirstPopup from "components/jiffy/j1-badge/j1-badge-popup/j1-badge-popup";

export default () => {
  initJiffyFirstPopup();
};
